import React, { useState } from 'react';
import './Footer.css';

const Footer = () => {
  const [referido, setReferido] = useState(localStorage.getItem('referedCode'))
  return (
<footer className="footer">
        <div className="footer__content">
          <div className="footer__info">
            <svg
              width="191"
              height="60"
              viewBox="0 0 191 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="footer__logo"
            >
              <g clip-path="url(#clip0_1_190)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.7016 7.1771C14.1698 7.1771 11.7415 8.18441 9.95171 9.97869C8.16193 11.773 7.15462 14.2058 7.15462 16.7466V20.7084C9.93822 18.7657 13.2614 17.7044 16.6971 17.7044H28.1508V7.1771H16.6971H16.7016ZM0.00899386 34.9322C0.130411 39.1997 1.87522 43.2695 4.89266 46.2959C8.02702 49.4392 12.2721 51.202 16.7016 51.202H26.334V44.0249H16.7016C14.1698 44.0249 11.7415 43.0176 9.95171 41.2234C8.16193 39.4291 7.15462 36.9962 7.15462 34.4555C7.15462 31.9147 8.16193 29.4819 9.95171 27.6876C11.7415 25.8933 14.1698 24.886 16.7016 24.886H35.3144V0H16.7016C12.2721 0 8.02252 1.7628 4.89266 4.90615C1.7583 8.04501 0 12.3081 0 16.7466V34.9322H0.00899386Z"
                  fill="url(#paint0_linear_1_190)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M38.0302 52.0927C40.5619 52.0927 42.9903 51.1034 44.7801 49.3361C46.5698 47.5733 47.5772 45.1809 47.5772 42.6851V38.7908C44.7981 40.6975 41.4703 41.7408 38.0347 41.7408H26.581V52.0882H38.0347L38.0302 52.0927ZM54.7273 24.8143C54.6059 20.6187 52.861 16.6209 49.8436 13.644C46.7137 10.5591 42.4641 8.82324 38.0347 8.82324H28.4022V15.8789H38.0347C40.5664 15.8789 42.9948 16.8682 44.7846 18.6355C46.5743 20.3983 47.5817 22.7907 47.5817 25.2865C47.5817 27.7823 46.5743 30.1747 44.7846 31.9375C42.9948 33.7003 40.5664 34.6941 38.0347 34.6941H19.4219V59.1484H38.0347C42.4641 59.1484 46.7137 57.4126 49.8436 54.3277C52.978 51.2428 54.7363 47.0561 54.7363 42.6896V24.8188H54.7318L54.7273 24.8143Z"
                  fill="url(#paint1_linear_1_190)"
                />
              </g>
              <path
                d="M83.0487 38.4007C79.5859 38.4007 76.641 37.268 74.2785 35.0027C71.916 32.7049 70.751 29.7599 70.751 26.1677C70.751 22.5431 71.9484 19.5657 74.3432 17.2356C76.7704 14.8732 79.683 13.7081 83.1135 13.7081C87.4177 13.7081 91.3012 15.7146 93.4047 18.7243L90.395 21.6046C88.4533 19.1774 86.0908 17.98 83.3076 17.98C81.0746 17.98 79.1652 18.7567 77.6118 20.3101C76.0908 21.8635 75.3141 23.8052 75.3141 26.1677C75.3141 28.4654 76.0584 30.3748 77.5795 31.8959C79.1005 33.4169 81.0099 34.1612 83.2753 34.1612C86.2203 34.1612 88.6151 32.9638 90.4921 30.5366L93.5665 33.3198C91.3335 36.3295 87.45 38.4007 83.0487 38.4007Z"
                fill="white"
              />
              <path
                d="M100.576 38.0447H96.3684V13.4492H100.478V22.7373C101.482 21.1515 103.553 20.0188 106.045 20.0188C107.954 20.0188 109.54 20.6661 110.867 21.9282C112.194 23.1903 112.873 24.9703 112.873 27.3327V38.0447H108.666V28.4654C108.666 25.5204 107.145 23.8699 104.815 23.8699C102.323 23.8699 100.576 25.7793 100.576 28.5301V38.0447Z"
                fill="white"
              />
              <path
                d="M130.438 22.7049V20.4719H134.451V38.0447H130.438V35.8764C128.917 37.5917 127.007 38.4654 124.71 38.4654C122.185 38.4654 120.114 37.5917 118.464 35.8117C116.813 34.0318 116.004 31.7988 116.004 29.1774C116.004 26.556 116.813 24.3554 118.464 22.6402C120.114 20.925 122.218 20.0512 124.71 20.0512C126.943 20.0512 128.852 20.925 130.438 22.7049ZM130.535 29.2421C130.535 27.7535 130.049 26.4913 129.079 25.4557C128.108 24.4201 126.878 23.9023 125.357 23.9023C123.836 23.9023 122.606 24.4201 121.635 25.4557C120.697 26.4913 120.211 27.7535 120.211 29.2421C120.211 30.7632 120.697 32.0253 121.635 33.0609C122.606 34.0965 123.836 34.6143 125.357 34.6143C126.878 34.6143 128.108 34.0965 129.079 33.0609C130.049 32.0253 130.535 30.7632 130.535 29.2421Z"
                fill="white"
              />
              <path
                d="M149.85 33.7082L151.177 37.0091C149.785 37.98 148.07 38.4654 146.096 38.4654C142.115 38.4654 140.076 36.103 140.076 31.6046V24.0318H137.164V20.4719H140.141V14.2583H144.316V20.4719H150.206V24.0318H144.316V31.4428C144.316 33.5463 145.157 34.6143 146.872 34.6143C147.843 34.6143 148.847 34.323 149.85 33.7082Z"
                fill="white"
              />
              <path
                d="M163.22 20.0512C165.711 20.0512 167.783 20.925 169.433 22.7049C171.116 24.4848 171.957 26.6531 171.957 29.2745C171.957 31.8959 171.116 34.0641 169.433 35.8441C167.783 37.5917 165.679 38.4654 163.187 38.4654C160.922 38.4654 159.045 37.5593 157.556 35.7146V38.0447H153.414V13.4492H157.621V22.7373C159.109 20.9573 160.986 20.0512 163.22 20.0512ZM167.653 29.2421C167.653 27.7535 167.168 26.4913 166.229 25.4881C165.291 24.4525 164.093 23.9347 162.572 23.9347C161.051 23.9347 159.821 24.4525 158.883 25.4881C157.944 26.4913 157.459 27.7535 157.459 29.2421C157.459 30.7632 157.944 32.0253 158.883 33.0609C159.821 34.0641 161.051 34.5819 162.572 34.5819C164.093 34.5819 165.291 34.0641 166.229 33.0609C167.168 32.0253 167.653 30.7632 167.653 29.2421Z"
                fill="white"
              />
              <path
                d="M182.23 32.3489L186.404 20.4719H191L183.88 39.1774C182.197 43.4816 180.061 45.5205 176.728 45.5205C175.401 45.5205 174.301 45.2292 173.492 44.679L174.171 41.1192C174.981 41.5075 175.725 41.7017 176.404 41.7017C177.796 41.7017 178.961 40.7632 179.835 38.8538L180.256 37.8829L172.586 20.4719H177.472L182.23 32.3489Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1_190"
                  x1="22.1069"
                  y1="25.1064"
                  x2="37.41"
                  y2="40.0676"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="white" />
                  <stop offset="0.76" stop-color="white" stop-opacity="0" />
                  <stop offset="1" stop-color="white" stop-opacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_1_190"
                  x1="32.6608"
                  y1="34.4378"
                  x2="17.6186"
                  y2="19.472"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="white" />
                  <stop offset="0.76" stop-color="white" stop-opacity="0" />
                  <stop offset="1" stop-color="white" stop-opacity="0" />
                </linearGradient>
                <clipPath id="clip0_1_190">
                  <rect width="54.7321" height="59.1481" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <ul className="footer__social-media">
              <li>
                <a
                  href="https://www.facebook.com/chatby.io"
                  target="_blank"
                  rel="noopener"
                  ><svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.7294 9.54356C15.7294 5.59689 12.5264 2.3938 8.57969 2.3938C4.63302 2.3938 1.42993 5.59689 1.42993 9.54356C1.42993 13.004 3.88945 15.8854 7.14974 16.5503V11.6885H5.71979V9.54356H7.14974V7.75612C7.14974 6.37621 8.27225 5.2537 9.65215 5.2537H11.4396V7.39863H10.0096C9.61641 7.39863 9.29467 7.72037 9.29467 8.11361V9.54356H11.4396V11.6885H9.29467V16.6576C12.9053 16.3001 15.7294 13.2543 15.7294 9.54356Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a href="https://linkedin.com/in/joysonllapo" target="_blank" rel="noopener">
                  <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.2849 11.0755H9.37911V8.08926C9.37911 7.37714 9.36464 6.46072 8.38601 6.46072C7.39237 6.46072 7.24062 7.23558 7.24062 8.03671V11.0755H5.33485V4.93461H7.16555V5.77167H7.19022C7.56395 5.13345 8.25823 4.75232 8.99732 4.77964C10.9278 4.77964 11.2854 6.05051 11.2854 7.70478V11.0755H11.2849ZM3.18006 4.09426C2.5688 4.09456 2.07304 3.59927 2.07274 2.98801C2.07245 2.37675 2.56773 1.88099 3.17899 1.88069C3.79025 1.8804 4.28601 2.37568 4.28631 2.98694C4.28673 3.2806 4.17034 3.56233 3.96281 3.77005C3.75528 3.97777 3.47365 4.09441 3.18003 4.09426L3.18006 4.09426ZM4.13473 11.0757H2.2236V4.93473H4.13473V11.0757ZM12.2366 0.108719H1.26851C1.01963 0.105715 0.779744 0.201712 0.601643 0.375589C0.423542 0.549467 0.321816 0.786978 0.318848 1.03586V12.0511C0.321675 12.3001 0.423357 12.5377 0.601489 12.7116C0.779622 12.8855 1.01959 12.9814 1.26852 12.9783H12.235C12.754 12.9848 13.1805 12.5701 13.1884 12.0511V1.03586C13.1805 0.516851 12.754 0.102153 12.235 0.108719H12.2366Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a href="https://www.tiktok.com/@joysonllapo" target="_blank" rel="noopener">
                  <img src="https://chatby.io/images/tik-tok.png" alt="" />
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/@Chatby-ai" target="_blank" rel="noopener"
                  ><svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.42029 12.9566L12.5949 10.5435L8.42029 8.13048V12.9566ZM17.7185 6.65852C17.8231 7.03656 17.8955 7.5433 17.9438 8.18678C18.0001 8.83026 18.0242 9.38526 18.0242 9.86787L18.0725 10.5435C18.0725 12.305 17.9438 13.6 17.7185 14.4285C17.5175 15.1524 17.0509 15.619 16.327 15.82C15.949 15.9246 15.2572 15.997 14.1955 16.0453C13.1499 16.1016 12.1927 16.1257 11.3079 16.1257L10.029 16.174C6.65876 16.174 4.55942 16.0453 3.73094 15.82C3.00703 15.619 2.5405 15.1524 2.33942 14.4285C2.23485 14.0505 2.16246 13.5437 2.1142 12.9003C2.0579 12.2568 2.03376 11.7018 2.03376 11.2192L1.9855 10.5435C1.9855 8.782 2.1142 7.487 2.33942 6.65852C2.5405 5.93461 3.00703 5.46809 3.73094 5.267C4.10898 5.16243 4.80072 5.09004 5.86246 5.04178C6.90811 4.98548 7.86529 4.96135 8.75007 4.96135L10.029 4.91309C13.3992 4.91309 15.4985 5.04178 16.327 5.267C17.0509 5.46809 17.5175 5.93461 17.7185 6.65852Z"
                      fill="#FFF5FE"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/chatby.io"
                  target="_blank"
                  rel="noopener"
                >
                  <svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.1553 2.39443C10.677 2.39243 11.1988 2.39768 11.7204 2.41016L11.8591 2.41517C12.0192 2.42089 12.1772 2.42804 12.3681 2.43662C13.1289 2.47237 13.6479 2.59248 14.1034 2.76908C14.5753 2.95069 14.9728 3.19664 15.3703 3.59416C15.7338 3.95137 16.0151 4.38346 16.1947 4.86039C16.3713 5.31583 16.4914 5.83561 16.5271 6.59635C16.5357 6.78653 16.5429 6.94526 16.5486 7.10541L16.5529 7.24412C16.5656 7.76547 16.5711 8.28698 16.5693 8.80848L16.57 9.34186V10.2785C16.5718 10.8002 16.5663 11.322 16.5536 11.8436L16.5493 11.9823C16.5436 12.1424 16.5364 12.3004 16.5279 12.4913C16.4921 13.2521 16.3706 13.7711 16.1947 14.2266C16.0157 14.704 15.7343 15.1364 15.3703 15.4935C15.0128 15.8569 14.5805 16.1382 14.1034 16.3179C13.6479 16.4945 13.1289 16.6146 12.3681 16.6503C12.1772 16.6589 12.0192 16.6661 11.8591 16.6718L11.7204 16.6761C11.1988 16.6888 10.677 16.6943 10.1553 16.6925L9.62191 16.6932H8.686C8.16426 16.695 7.64251 16.6895 7.12092 16.6768L6.98221 16.6725C6.81249 16.6664 6.6428 16.6592 6.47315 16.6511C5.71242 16.6153 5.19334 16.4938 4.73719 16.3179C4.26008 16.1387 3.82791 15.8573 3.47097 15.4935C3.10708 15.1362 2.82551 14.7039 2.64589 14.2266C2.46929 13.7711 2.34917 13.2521 2.31342 12.4913C2.30546 12.3217 2.29831 12.152 2.29197 11.9823L2.2884 11.8436C2.27522 11.322 2.26926 10.8002 2.27052 10.2785V8.80848C2.26853 8.28698 2.27377 7.76547 2.28625 7.24412L2.29126 7.10541C2.29698 6.94526 2.30413 6.78653 2.31271 6.59635C2.34846 5.8349 2.46857 5.31654 2.64517 4.86039C2.8249 4.38323 3.10702 3.95125 3.47168 3.59488C3.82838 3.23078 4.26027 2.94895 4.73719 2.76908C5.19334 2.59248 5.7117 2.47237 6.47315 2.43662L6.98221 2.41517L7.12092 2.41159C7.64227 2.39842 8.16377 2.39246 8.68529 2.39372L10.1553 2.39443ZM9.42028 5.96931C8.94662 5.96261 8.47634 6.05012 8.03679 6.22675C7.59723 6.40338 7.19717 6.66561 6.85984 6.9982C6.52252 7.33079 6.25466 7.72711 6.07183 8.16412C5.889 8.60113 5.79485 9.07012 5.79485 9.54384C5.79485 10.0175 5.889 10.4865 6.07183 10.9236C6.25466 11.3606 6.52252 11.7569 6.85984 12.0895C7.19717 12.4221 7.59723 12.6843 8.03679 12.8609C8.47634 13.0375 8.94662 13.1251 9.42028 13.1184C10.3684 13.1184 11.2777 12.7417 11.9481 12.0713C12.6185 11.4009 12.9952 10.4916 12.9952 9.54348C12.9952 8.59536 12.6185 7.68608 11.9481 7.01566C11.2777 6.34524 10.3684 5.96931 9.42028 5.96931ZM9.42028 7.39927C9.70521 7.39402 9.98832 7.44559 10.2531 7.55099C10.5178 7.65638 10.759 7.81348 10.9623 8.0131C11.1657 8.21273 11.3272 8.45087 11.4375 8.71363C11.5478 8.9764 11.6047 9.2585 11.6047 9.54347C11.6048 9.82844 11.548 10.1106 11.4378 10.3734C11.3276 10.6362 11.1661 10.8744 10.9628 11.0741C10.7595 11.2737 10.5185 11.4309 10.2537 11.5364C9.98902 11.6419 9.70592 11.6936 9.421 11.6884C8.85213 11.6884 8.30656 11.4624 7.9043 11.0602C7.50205 10.6579 7.27607 10.1123 7.27607 9.54348C7.27607 8.97461 7.50205 8.42904 7.9043 8.02678C8.30656 7.62453 8.85213 7.39855 9.421 7.39855L9.42028 7.39927ZM13.1739 4.89685C12.9432 4.90608 12.7251 5.0042 12.5652 5.17067C12.4052 5.33713 12.3159 5.55901 12.3159 5.78985C12.3159 6.0207 12.4052 6.24258 12.5652 6.40904C12.7251 6.57551 12.9432 6.67363 13.1739 6.68286C13.4109 6.68286 13.6383 6.5887 13.8059 6.42109C13.9735 6.25349 14.0676 6.02617 14.0676 5.78914C14.0676 5.55211 13.9735 5.32479 13.8059 5.15718C13.6383 4.98958 13.4109 4.89542 13.1739 4.89542V4.89685Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </li>
            </ul>
            <div className="footer__partners">
              <div className="footer__partner">
                <img src="https://chatby.io/images/Frame-531.png" alt="" />
                <img src="https://chatby.io/images/Frame-532.png" alt="" />
              </div>
              <div className="footer__partner">
                <img src="https://chatby.io/images/Meta-Badge.png" alt="" />
                <img src="https://chatby.io/images/dialog.png" alt="" />
              </div>
            </div>
          </div>
          <div className="footer__links-group">
            <div>
              <p className="footer__group-title">Chatby</p>
              <div className="footer__links">
                <ul>
                  <li>
                    <a href="https://chatby.io" target="_blank" rel="noopener">Nosotros</a>
                  </li>
                  <li><a  target="_blank" rel="noopener" onClick={`https://chatby.io/pricing`}>Planes</a></li>
                  <li>
                    <a href="https://app.chatby.io" target="_blank" rel="noopener">Contacto</a>
                  </li>
                </ul>
                <ul>
                  <li>
                    <a href="https://chatby.io/partners" target="_blank" rel="noopener">Partners</a>
                  </li>
                  <li>
                    <a
                      href={`https://chatby.io/register${referido? `?ref=${referido}` :'?ref=Web'}`}
                      target="_blank"
                      rel="noopener"
                      >Prueba gratuita</a
                    >
                  </li>
                  <li>
                    <a  target="_blank" rel="noopener">Casos de éxito</a>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <p className="footer__group-title">Recursos</p>
              <div className="footer__links">
                <ul>
                  <li>
                    <a
                      href="https://app.chatby.io/api"
                      target="_blank"
                      rel="noopener"
                      >Desarrolladores</a
                    >
                  </li>
                  <li><a  target="_blank" rel="noopener">Status</a></li>
                  <li><a target="_blank" rel="noopener">Roadmap</a></li>
                </ul>
                <ul>
                  <li>
                    <a href="https://chatby.io" target="_blank" rel="noopener"
                      >Centro de ayuda</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/groups/chatby.io"
                      target="_blank"
                      rel="noopener"
                      >Facebook Comunidad</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://whatsapp.com/channel/0029Va5hhmf17En2PE0zp42T"
                      target="_blank"
                      rel="noopener"
                      >Whatsapp Comunidad</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="footer__legal-terms">
          <p>©2024, CHATBY SAC, RUC 20606449993</p>
          <div>
            <a  target="_blank" rel="noopener"
              >POLÍTICA DE PRIVACIDAD</a
            >
            <a target="_blank" rel="noopener">TÉRMINOS DE SERVICIO</a>
          </div>
        </div>
      </footer>
  );
};

export default Footer;